import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/history.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b78ad58"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_DocumentsHistoryDialog = _resolveComponent("DocumentsHistoryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "badge-danger btn tw-document-trigger-btn svg-container",
      onClick: _ctx.toggleShowControls,
      floating: ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_q_tooltip, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("order.tooltip.documentsHistory")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.toggleShow)
      ? (_openBlock(), _createBlock(_component_DocumentsHistoryDialog, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}